export default "__VITE_ASSET__CGYgWJkG__"